import { Helmet } from 'react-helmet-async';

const SITE = 'https://govindaniit.com';

interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  keywords?: string;
  schema?: object;
  noindex?: boolean;
}

const SEO = ({
  title,
  description,
  canonical,
  ogImage = 'https://pub-8d8c06eb82144fca803dab6ccecd7b41.r2.dev/Images/LOGO.webp',
  ogType = 'website',
  keywords = '',
  schema,
  noindex = false,
}: SEOProps) => {
  // Derive the canonical from the page actually being rendered. Defaulting it
  // to the site root made 26 components declare the homepage as their canonical.
  const path = typeof window !== 'undefined' ? window.location.pathname : '/';
  const resolved = canonical
    ? (canonical.endsWith('/') || canonical === SITE ? canonical : `${canonical}/`)
    : `${SITE}${path.endsWith('/') ? path : `${path}/`}`;

  const fullTitle = title.includes('Govindani') ? title : `${title} | Govindani Infotech`;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={resolved} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={resolved} />
      <meta property="og:site_name" content="Govindani Infotech" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
